import { render } from "./in-grid-banner.vue?vue&type=template&id=231832e0"
import script from "./in-grid-banner.vue?vue&type=script&lang=js"
export * from "./in-grid-banner.vue?vue&type=script&lang=js"

import "./in-grid-banner.vue?vue&type=style&index=0&id=231832e0&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__